var TokenRepository = require('./token_repository');
var BillingInformationRelayer = require('./billing_information_relayer');
var IframeMessenger = require('../iframe_messenger/iframe_messenger.js');

var EmbeddedTokenServiceClient = function(){
    var tokenServiceUrl = window.location.protocol + "//" + window.location.host;
    var tokenRepository = TokenRepository(tokenServiceUrl);
    var iframeMessenger = IframeMessenger.Inside(IframeMessenger.DefaultMessageEventListener());
    var billingInformationRelayer = BillingInformationRelayer(tokenRepository, iframeMessenger);

    billingInformationRelayer.listenForMessagesAndRelayToTokenService();

    return {
        cleanup: function() {
            iframeMessenger.destroy();
        }
    }
};

module.exports = EmbeddedTokenServiceClient;
